export default "__VITE_ASSET__3rdksqwg__"